import React, { FC } from 'react';
import { GoBackButton } from '../goBackButton/goBackButton';

type Props = {
  title?: string;
  className?: string;
  children: React.ReactNode;
};

export const SectionBase: FC<Props> = ({ title, children, className }) => {
  return (
    <div
      className={`flex max-h-[700px] min-h-[100px] flex-col rounded-[10px] border bg-white px-5 pb-4 pt-4 shadow-lg min-[1024px]:max-h-full ${
        className ?? ''
      }`}
      data-cy="section-base"
    >
      <div className="flex self-start w-full min-[768px]:w-auto">
        <GoBackButton />
        <div className="w-full justify-center text-center">
          {title && <h2 className="py-2 text-[26px] font-bold">{title}</h2>}
        </div>
      </div>
      <div className="mb-[20px]">{children}</div>
    </div>
  );
};
